// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1495":"ba56f75d9c05ac1e","4684":"c2e7011e838613a0","9875":"9528376c45c08fde"}[chunkId] + ".css";
};